import datacentral from '@/utils/axios/datacentral'
import {
    Business,
    BusinessExplaination,
    BusinessSummary,
    RelatedBusiness,
} from '../types/response'
import {
    ErrorResponse,
    ResponseArray,
    ResponseObject,
    QueryParams,
} from '@/types/shared'
import {
    BusinessApprovePayload,
    BusinessBodApprovePayload,
    BusinessCancelledPayload,
    BusinessDetailPayload,
    BusinessExplainationPayload,
    BusinessLeaderApprovePayload,
    BusinessNewPayload,
} from '../types/payload'
import qs from 'query-string'
import {
    getCustomerContains,
    getCustomerOptions,
} from '@/modules/Customer/services'
/** Get businesses for employee (with sorting support) */
export const getBusinessesList = async (
    params: QueryParams
): Promise<ResponseArray<Business>> => {
    const response = await datacentral.get(
        `/businesses?${qs.stringify(params)}`
    )
    return response.data
}

/** Get all businesses for HRM (with sorting support) */
export const getAllBusinessesList = async (
    params: QueryParams
): Promise<ResponseArray<Business>> => {
    const response = await datacentral.get(
        `/businesses/businesses_all?${qs.stringify(params)}`
    )
    return response.data
}
export const getBusinessByID = async (payload: BusinessDetailPayload) => {
    const response = await datacentral.get<
        ResponseObject<BusinessExplaination>
    >(`/businesses/${payload.business_id}`)
    return response.data
}
export const cancelledBusinessByID = async (
    payload: BusinessCancelledPayload
) => {
    const response = await datacentral.put<ResponseObject<Business>>(
        `/businesses/${payload.business_id}`,
        {
            business_reason_cancelled: payload.business_reason_cancelled,
        }
    )
    return response.data
}
export const createBusiness = async (
    payload: BusinessNewPayload
): Promise<ResponseObject<Business> | ErrorResponse> => {
    const response = await datacentral.post('/businesses', payload)
    return response.data
}
export const approveLeaderBusiness = async (
    payload: BusinessLeaderApprovePayload
) => {
    const response = await datacentral.put<ResponseObject<Business>>(
        `/businesses/${payload.business_id}/lead/approve`,
        {
            business_leader_feedback: payload.business_leader_feedback,
        }
    )
    return response.data
}
export const approveBodBussiness = async (
    payload: BusinessBodApprovePayload
) => {
    const response = await datacentral.put<ResponseObject<Business>>(
        `/businesses/${payload.business_id}/bod/approve`,
        {
            business_bod_feedback: payload.business_bod_feedback,
        }
    )
    return response.data
}
export const approveBusiness = async (payload: BusinessApprovePayload) => {
    const response = await datacentral.put<ResponseObject<Business>>(
        `/businesses/${payload.business_id}/approve`,
        {
            business_feedback: payload.business_feedback,
        }
    )
    return response.data
}

export const updateBusinessExplaination = async (
    payload: BusinessExplainationPayload
) => {
    const response = await datacentral.put<BusinessExplaination>(
        `/businesses/${payload.business_id}/explaination`,
        payload
    )
    return response.data
}
// export const getCustomerOptionsAsync = async (value: string) => {
//     return getCustomerOptions({
//         q: value,
//         page: 1,
//         page_size: 5
//     });
// };
export const getCustomerOptionsAsync =
    (customerIdSearch: string) =>
    async (value: string): Promise<{ label: string; value: number }[]> => {
        const options = await getCustomerOptions({
            q: value,
            page: 1,
            page_size: 5,
        })

        // Only fetch customer detail if not already in options
        const customerExists = options?.find(
            (option) => option.value.toString() === customerIdSearch
        )

        if (!customerExists && customerIdSearch) {
            try {
                const [customerOption] = await getCustomerContains({
                    customer_ids: [parseInt(customerIdSearch, 10)],
                })
                if (customerOption) {
                    options.push(customerOption)
                }
            } catch {
                // Customer not found or API error - continue with existing options
            }
        }

        return options
    }

export const getBusinessSummary = async () => {
    const response = await datacentral.get<ResponseObject<BusinessSummary>>(
        `/businesses/statistical`
    )
    return response.data
}

export const getRelatedBusinesses = async (businessId: number) => {
    const response = await datacentral.get<ResponseArray<RelatedBusiness>>(
        `/businesses/${businessId}/related`
    )
    return response.data
}
